module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAAg0lEQVQokZXTWwrEIAyF4b9QcHuzI+mK5q1d2zydElCmFxP1QBCi+RDBRRIluawbc7nPGSgp659ceiP1mrPmKunQPSNofsyYsdbNNIm2sFRvOIu62BMcQUOsBVZ0b6BdzAM9tItFYIS6WA9svWmIWV1/ipcEfIEF+AC/6PAIWFFLiAGcGnxomGX/OhoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regular/funding/icon-arrow-white.png
// module id = tr06
// module chunks = 1